import React from "react";
import FilterChipDisplay from "../../FilterChipDisplay";
import Typography from "@mui/material/Typography";

interface IClientProps {
    name: string
}

export default function ClientDisplayChip(props: IClientProps) {
    const text =
        <Typography variant="body1">{props.name}</Typography>

    return (
        <FilterChipDisplay text={text} />
    )
}